import React, { useState } from "react";
import { AppProvider, CalloutCard, Banner } from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { ExportIcon } from "@shopify/polaris-icons";
import Filedownload from "../assets/img/filedownload.svg";

export default function ExportData() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [loadingType, setLoadingType] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleExport = async (type) => {
    if (!token) {
      setError("User not authenticated.");
      return;
    }
    setLoadingType(type);
    setError("");
    setSuccess("");
    try {
      const response = await fetch(`${baseUrl}/api/export/${type}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "text/csv",
        },
      });

      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const filename = `${type}-export-${new Date().toISOString().split("T")[0]
        }.csv`;

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setSuccess(
        `${type.charAt(0).toUpperCase() + type.slice(1)} export successful!`
      );
    } catch (err) {
      setError(`Export failed: ${err.message}`);
    } finally {
      setLoadingType(null);
    }
  };

  return (
    <AppProvider i18n={en}>
      <div className="button_option">
        <h2>Export CSV Data</h2>
      </div>

      {success && (
        <div className="mess_banner">
          <Banner title="Success" status="success">
            <p>{success}</p>
          </Banner>
        </div>
      )}

      {error && (
        <Banner title="Error" status="critical">
          <p>{error}</p>
        </Banner>
      )}

      <div className="file_csv">
        {/* <CalloutCard
          title="Export Orders"
          illustration={Filedownload}
          primaryAction={{
            content: "Export Orders",
            onAction: () => handleExport("orders"),
            icon: ExportIcon,
            variant: "primary",
            loading: loadingType === "orders",
          }}
        >
          <p>
          Easily export order data for reporting, analysis, or backup. Download order details in CSV format.
          </p>
        </CalloutCard> */}

        <CalloutCard
          title="Export Customers"
          illustration={Filedownload}
          primaryAction={{
            content: "Export Customers",
            onAction: () => handleExport("customers"),
            icon: ExportIcon,
            variant: "primary",
            loading: loadingType === "customers",
          }}
        >
          <p>
            Download your customer list with detailed information such as names,
            email addresses, and purchase history. Useful for marketing, CRM
            integration, or data analysis.
          </p>
        </CalloutCard>
      </div>
    </AppProvider>
  );
}
